import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-reward-plan',
  templateUrl: './reward-plan.component.html',
  styleUrls: ['./reward-plan.component.scss']
})
export class RewardPlanComponent implements OnInit {

  scrollContent: any[] = [];

  constructor(public userService: UserService) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.createScrollContent();
  }

  createScrollContent(): void {
    const phrases = [
      "Loyalty Rewards",
      "Earn Points",
      "Exclusive Offers", 
      "Easy Redemption",
      "Tangerine.fun",
      "Rewards Program",
      "Start Earning",
      "Join Today",
      "Special Offers",
      "Loyalty Points"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  isLoggedIn() {
    if (
      Object.keys(this.userService.userServiceModal.customerData).length &&
      this.userService.userServiceModal.customerData.CustomerId &&
      this.userService.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }

}
